import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Material } from '../../../portfolio/interfaces/material.interface';
import { PromocionesService } from '../../services/promociones.service';
import { MaterialPresentacion } from 'src/app/model/datos-maestros/materialPresentacion';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { ToastrService } from 'ngx-toastr';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { ApiResponse } from 'src/app/model/interfaces/response';

@Component({
  selector: 'app-promo-regalo-form',
  templateUrl: './promo-regalo-form.component.html',
  styleUrls: ['./promo-regalo-form.component.css']
})
export class PromoRegaloFormComponent {

  agregarFormBonificadorRegalo!: FormGroup;
  comboPresentaciones: MaterialPresentacion[] = [];
  materialTitle: string = '';
  _regalo?: any;

  @Input()
  set regalo(data: any | undefined) {
    if (data) {
      this.agregarFormBonificadorRegalo.patchValue(data);
      this.agregarFormBonificadorRegalo.get("id_promo_ant").setValue(data.id_promo);
      this.agregarFormBonificadorRegalo.get("id_material_ant").setValue(data.id_material);
      this.agregarFormBonificadorRegalo.get("id_unidad_ant").setValue(data.id_unidad);
      this.agregarFormBonificadorRegalo.get("relacion21_ant").setValue(data.relacion21);
      this.materialTitle = `${data.id_material}-${data.name_material}`;
      this.findPresentaciones(data.id_material);
      this._regalo = data;
    }
  }

  @Input()
  set idPromo(id: string) {
    this.agregarFormBonificadorRegalo.get('id_promo').setValue(id);
  }

  @Input()
  set tipoPromo(tipo: string) {
    this.onChangeTipo(tipo);
  }

  @Input()
  set material(material: Material | undefined) {
    if (material) {
      this.agregarFormBonificadorRegalo.get('id_material').setValue(material.idMaterial);
      this.materialTitle = `${material.idMaterial}-${material.dscaMaterial}`;
      this.findPresentaciones(material.idMaterial);
    }
  }

  @Output()
  back = new EventEmitter<void>();

  @Output()
  create = new EventEmitter<any>();

  @ViewChild('fileInput')
  fileInput: ElementRef;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly toastrService: ToastrService,
    private readonly maestroService: DatosMaestrosService,
    private readonly promocionesService: PromocionesService,
    private readonly _util: UtilsService,
  ) {
    this.buildForm();
  }

  private buildForm() {
    this.agregarFormBonificadorRegalo = this.formBuilder.group({
      id_promo: ['', []],
      id_promo_ant: ['', []],
      id_material: ['', [Validators.required]],
      id_material_ant: ['', []],
      id_unidad: ['', [Validators.required]],
      id_unidad_ant: ['', []],
      cantidad1: [null, [Validators.min(1), Validators.max(99999)]],
      cantidad2: [null, [Validators.min(1), Validators.max(99999)]],
      cantidad3: [null, [Validators.min(1), Validators.max(99999)]],
      relacion21: [null, [Validators.min(1)]],
      relacion21_ant: [null, []],
    });
  }

  accionesBonificadoresRegalo(event: string) {
    if (event === 'guardar') {
      this.create.emit(this.agregarFormBonificadorRegalo.getRawValue());
    } else {
      this.back.emit();
    }
  }

  setALLNoRequiredAndEnable() {
    Object.keys(this.agregarFormBonificadorRegalo.controls).forEach(key => {
      this.agregarFormBonificadorRegalo.get(key).setValidators([]);
      this.agregarFormBonificadorRegalo.get(key).updateValueAndValidity();
      this.agregarFormBonificadorRegalo.get(key).enable();
    });

    this.agregarFormBonificadorRegalo.get('cantidad1').setValidators([Validators.min(1), Validators.max(99999)]);
    this.agregarFormBonificadorRegalo.get('cantidad2').setValidators([Validators.min(1), Validators.max(99999)]);
    this.agregarFormBonificadorRegalo.get('cantidad3').setValidators([Validators.min(1), Validators.max(99999)]);
    this.agregarFormBonificadorRegalo.get('relacion21').setValidators([Validators.min(1)]);
    this.agregarFormBonificadorRegalo.get('id_material').setValidators([Validators.required]);
    this.agregarFormBonificadorRegalo.get('id_unidad').setValidators([Validators.required]);
    if(!this._regalo) {
      this.agregarFormBonificadorRegalo.get('cantidad1').setValue(0);
      this.agregarFormBonificadorRegalo.get('cantidad2').setValue(0);
      this.agregarFormBonificadorRegalo.get('cantidad3').setValue(0);
      this.agregarFormBonificadorRegalo.get('relacion21').setValue(0);
    }
  }

  setKeyEmptyDisabled(key, value = null) {
    // console.log("form, key", form, key)
    this.agregarFormBonificadorRegalo.get(key).setValue(value);
    this.agregarFormBonificadorRegalo.get(key).setValidators([]);
    this.agregarFormBonificadorRegalo.get(key).updateValueAndValidity();
    this.agregarFormBonificadorRegalo.get(key).disable();
  }

  onChangeTipo(tipo: string) {
    this.setALLNoRequiredAndEnable();
    switch (tipo.toString()) {
      case '1':
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('relacion21');
        break;
      case '2':
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('relacion21');
        break;
      case '3':
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        break;
      case '4':
        this.setKeyEmptyDisabled('relacion21');
        break;
      case '5':
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('relacion21');
        break;
      case '6':
        this.setKeyEmptyDisabled('id_material');
        this.setKeyEmptyDisabled('id_unidad');
        this.setKeyEmptyDisabled('cantidad1');
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('relacion21');
        break;
      case '7':
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('relacion21');
        break;
      case '8':
        this.setKeyEmptyDisabled('id_material');
        this.setKeyEmptyDisabled('id_unidad');
        this.setKeyEmptyDisabled('cantidad1');
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('relacion21');
        break;
      case '9':
        this.setKeyEmptyDisabled('id_material');
        this.setKeyEmptyDisabled('id_unidad');
        this.setKeyEmptyDisabled('cantidad1');
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('relacion21');
        break;
      // case 'COMBO_VIRTUAL' T.25842.sn
      case '10':
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('relacion21');
        break; 
      //T.25842.en   
    }
  }

  findPresentaciones(material: number) {
    this.maestroService.getMaterialPresentacion(material).subscribe((res) => this.comboPresentaciones = res);
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.toastrService.error('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV"');
        this.fileInput.nativeElement.value = '';
      } else {
        this.uploadCsv(file);
      }
    }
  }

  private uploadCsv(file) {
    const formData = new FormData();
    formData.append('file', new Blob([file], { type: 'text/csv' }), 'file');
    this._util
      .confirmarSincronoPromesa({
        title: '¿Esta seguro de enviar el siguiente archivo?',
        text: '',
        action: 'Enviar',
        funcion: this.promocionesService.regaloCsv(this.agregarFormBonificadorRegalo.get('id_promo').value, formData)
      })
        .then((res: ApiResponse<string>) => {
          this.toastrService.success(res.mensaje, `${res.key}`);
        })
        .finally(() => this.fileInput.nativeElement.value = '');
  }
}
